import styled from "styled-components";

export const CommentContainer = styled.div`
  width: 100vw;
  height: calc(100vh - 121px);
  & div {
    min-width: 100%;
  }
`;
